import React from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";
import { Input } from "../../../../ui/inputs/Input";

export default function CambiarClaveSupervisorContabilidad({ show, setShow, setTabla }) {
  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="md" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Cambiar Contraseña Supervisor</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2">
        <div className="col-12 m-0 mb-2 p-0">
          <Input label = 'Usuario:' />
        </div>
        <div className="col-12 m-0 mb-2 p-0">
          <Input label = 'Contraseña Nueva:' />
        </div>
        <div className="col-12 m-0 p-0">
          <Input label = 'Confirmar Contraseña:' />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
